// Draft/Reserved → Cancelled, from the ⋯ menu. Draft: nobody is notified.
// Reserved: the dialog lists exactly who gets the cancellation (from
// cancel_action.effects — same lines Reserve shows, parallel-run aware).
import React, { useState } from 'react';
import { UI, fmtMoney, useIsNarrow } from './pipeline';

export default function CancelConfirm({ order, onClose, transition, onDone }) {
  const narrow = useIsNarrow();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const ca = order.cancel_action || {};
  const paid = Number(order.amount_paid || 0);

  async function go() {
    setBusy(true); setErr(null);
    const r = await transition(order, { action: 'cancel' });
    setBusy(false);
    if (r.ok) onDone(r.order); else setErr(r.reason);
  }

  return (
    <div style={UI.overlay(narrow)} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={UI.box(narrow, 440)} data-testid="cancel-dialog" role="dialog">
        <div style={UI.head}>
          <div><div style={UI.title}>{ca.label || 'Cancel order'} — {order.order_number || '#' + order.id}</div><div style={UI.sub}>{order.client_name} · currently {order.next_action?.status_label || order.status}</div></div>
          <button style={UI.close} onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div style={UI.body}>
          <label style={UI.lbl}>What happens</label>
          {(ca.effects || []).map((line, i) => <div key={i} style={UI.effect}>• {line}</div>)}
          {paid > 0 && <div style={{ marginTop: 12, padding: '8px 10px', background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.3)', borderRadius: 6, fontSize: 12, color: '#fbbf24' }}>
            This order has {fmtMoney(paid)} paid — refund it separately.
          </div>}
          {!ca.enabled && <div style={{ marginTop: 10, color: '#f87171', fontSize: 12 }}>{ca.reason}</div>}
          {err && <div style={{ marginTop: 10, color: '#f87171', fontSize: 12 }} data-testid="dialog-error">{err}</div>}
        </div>
        <div style={UI.foot}>
          <button style={UI.cancelBtn} onClick={onClose}>Keep order</button>
          <button data-testid="cancel-confirm" disabled={busy || !ca.enabled} onClick={go} style={UI.goBtn(!busy && ca.enabled, '#7f1d1d', '#fecaca')}>
            {busy ? 'Cancelling…' : ca.label || 'Cancel order'}
          </button>
        </div>
      </div>
    </div>
  );
}
